<vn-page-matrix *ngIf="isPagematrixReady" [content]="content | dsl | async"></vn-page-matrix>
